import React from "react";
import loading_img from 'src/assets/images/loading.svg';

export const LoadingSpinner = () =>
{
    return <img src={loading_img} alt="loading" width="25px" />
}
